export class AsyncActionType {
    constructor(actionType) {
        this.STARTED = actionType+'_STARTED';
        this.SUCCEEDED = actionType+'_SUCCEEDED';
        this.FAILED = actionType+'_FAILED';
        this.ENDED = actionType+'_ENDED';

    }
}
export const getAsyncTypes = (actionType) => new AsyncActionType(actionType); 


// WEBPACK FOOTER //
// ./src/helpers/actionType.js